import React from 'react';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CategorySkill from './CategorySkill';

const BookLessonSkill: React.FC<{
  lesson;
}> = ({ lesson }) => {

  return (
    <>
      {lesson.skills && lesson.skills.length > 0 && (
        <div className="community-data">
          <div className="d-flex">
          <div className="community-title">{'Dữ liệu cộng đồng đóng góp' /*Translate('data-community-contributions', 'Dữ liệu cộng đồng đóng góp')*/}</div>
            <div className="flex-grow-1 community-icon">
              <FontAwesomeIcon className="text-success" icon={faGlobe} />
            </div>
          </div>
          <div className='community-data-skill'>
            {lesson.skills?.map((skill, n) => (
              <CategorySkill
                key={n}
                index={n}
                skill={skill}
                showIndex
                lessonId={lesson.id}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default BookLessonSkill;
